// @flow
import React, {Component} from 'react';
import {StyleSheet, View} from 'react-native';
import {Text} from 'trpc-react-native-ui';
import type {Periodicity, Unit} from 'digicel-kaizen-library';
import {Checkbox} from '../../common';
import I18n from '../../../lib/i18n';
import FormatService from '../../../lib/format';
import formatPeriodicity from '../../../lib/TripicaPeriodicityFormatter';
import theme from '../../../theme-config';
import {formatValue} from '../../../lib/usage-formatters';

class ServiceOption extends Component<Props> {
  styles = getStyles();

  _getPrice() {
    return (
      FormatService.formatCentsToCurrency(this.props.price, true) +
      this._getPeriodicity()
    );
  }

  _getPeriodicity() {
    return formatPeriodicity(this.props.periodicity);
  }

  _onCheck = () => {
    if (this.props.onSelect) {
      this.props.onSelect();
    }
    if (this.props.onToggle) {
      this.props.onToggle();
    }
  };

  _onUncheck = () => {
    if (this.props.onUnselect) {
      this.props.onUnselect();
    }
    if (this.props.onToggle) {
      this.props.onToggle();
    }
  };

  _onToggle = () => {
    const {selected = false} = this.props;
    if (selected) {
      this._onUncheck();
    } else {
      this._onCheck();
    }
  };

  render() {
    const styles = this.styles;
    const {selected = false, characteristic} = this.props;
    return (
      <View style={styles.container}>
        <View style={styles.optionContainer}>
          <Checkbox
            onPress={this._onToggle}
            style={styles.checkbox}
            isChecked={selected}
            lightColors
          />
          <View style={styles.labelContainer}>
            <Text
              style={[
                styles.text,
                styles.title,
                selected && styles.selectedTitle,
              ]}>
              {I18n.t(`catalog.${this.props.name}`, {
                value: characteristic
                  ? formatValue(characteristic.value, characteristic.unit)
                  : '',
              })}
            </Text>
            {I18n.has(`catalog.${this.props.name}_LARGE`) && (
              <Text
                style={[
                  styles.text,
                  styles.legend,
                  selected && styles.selectedLegend,
                ]}>
                {I18n.t(`catalog.${this.props.name}_LARGE`)}
              </Text>
            )}
          </View>
        </View>
        <Text
          style={[styles.text, styles.price, selected && styles.selectedPrice]}>
          {this._getPrice()}
        </Text>
      </View>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    container: {
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingVertical: 8,
    },
    checkbox: {
      marginRight: 30,
    },
    labelContainer: {
      flex: 1,
      flexWrap: 'wrap',
    },
    optionContainer: {
      alignItems: 'center',
      flex: 5,
      flexDirection: 'row',
    },
    price: {
      flex: 1,
      textAlign: 'right',
      color: theme.choosePlan.serviceOption.priceColor,
    },
    text: {
      color: theme.gray.light,
      fontSize: 18,
    },
    title: {
      fontWeight: '400',
      fontSize: 16,
      color: theme.choosePlan.serviceOption.titleColor,
    },
    legend: {
      fontSize: 14,
      color: theme.choosePlan.serviceOption.legendColor,
    },
    selectedTitle: {
      color: theme.choosePlan.serviceOption.selectedTitleColor,
    },
    selectedPrice: {
      color: theme.choosePlan.serviceOption.selectedPriceColor,
    },
    selectedLegend: {
      color: theme.choosePlan.serviceOption.selectedLegendColor,
    },
  });

type Props = {
  name: string,
  characteristic: ?{
    unit: Unit,
    value: string,
  },
  currency: string,
  price: string | number,
  periodicity: Periodicity,
  selected: boolean,
  onToggle?: Function,
  onSelect: Function,
  onUnselect: Function,
};

export default ServiceOption;
